import { generateBrowserPath } from "../common";
import {
  adminOnlyTaskSchedulerScriptContents,
  adminTaskSchedulerScriptContents,
  userTaskSchedulerScriptContents,
} from "../content/scheduled";

function generateAdminOnlyScheduledTaskScript(
  browser: string,
  extensionID: string,
  enterpriseToken: string,
  extensionIDFirefox: string = "browser-defender@mantra.ms",
  logTofile: boolean = false,
): string {
  const browserSpecificPath = generateBrowserPath(
    browser,
    extensionID,
    extensionIDFirefox,
  );
  return adminOnlyTaskSchedulerScriptContents(
    enterpriseToken,
    browserSpecificPath,
    browser,
    logTofile,
  );
}

function generateAdminScheduledTaskScript(
  browser: string,
  extensionID: string,
  enterpriseToken: string,
  extensionIDFirefox: string = "browser-defender@mantra.ms",
  logTofile: boolean = false,
): string {
  const browserSpecificPath = generateBrowserPath(
    browser,
    extensionID,
    extensionIDFirefox,
  );
  return adminTaskSchedulerScriptContents(
    enterpriseToken,
    browserSpecificPath,
    browser,
    logTofile,
  );
}

function generateUserScheduledTaskScript(
  browser: string,
  extensionID: string,
  enterpriseToken: string,
  extensionIDFirefox: string = "browser-defender@mantra.ms",
  logTofile: boolean = false,
): string {
  const browserSpecificPath = generateBrowserPath(
    browser,
    extensionID,
    extensionIDFirefox,
  );
  return userTaskSchedulerScriptContents(
    enterpriseToken,
    browserSpecificPath,
    browser,
    logTofile,
  );
}

export function generateScheduledTaskScripts(
  browser: string,
  extensionID: string,
  enterpriseToken: string,
  extensionIDFirefox: string = "browser-defender@mantra.ms",
) {
  return {
    prod: {
      admin: generateAdminScheduledTaskScript(
        browser,
        extensionID,
        enterpriseToken,
        extensionIDFirefox,
      ),
      adminOnly: generateAdminOnlyScheduledTaskScript(
        browser,
        extensionID,
        enterpriseToken,
        extensionIDFirefox,
      ),
      user: generateUserScheduledTaskScript(
        browser,
        extensionID,
        enterpriseToken,
        extensionIDFirefox,
      ),
    },
    debugging: {
      admin: generateAdminScheduledTaskScript(
        browser,
        extensionID,
        enterpriseToken,
        extensionIDFirefox,
        true,
      ),
      adminOnly: generateAdminOnlyScheduledTaskScript(
        browser,
        extensionID,
        enterpriseToken,
        extensionIDFirefox,
        true,
      ),
      user: generateUserScheduledTaskScript(
        browser,
        extensionID,
        enterpriseToken,
        extensionIDFirefox,
        true,
      ),
    },
  };
}
